<ng-container *transloco="let t">
  <div class="h-layout">
    <div class="flex h-19 items-center justify-between py-xs">
      @if (agencyLogo) {
        <div class="relative h-[20px] w-auto min-w-[130px]">
          <img
            [ngSrc]="agencyLogo.url"
            [alt]="agencyLogo.title"
            class="object-contain object-left"
            content="logo"
            fill
            alt=""
            priority
          />
        </div>
      } @else {
        <a [routerLink]="linkService.homePath" class="cursor-pointer pr-sm">
          <img
            ngSrc="assets/images/buildigo.svg"
            width="126"
            height="30"
            priority
            alt=""
            class="-mb-2xs h-[20px] object-contain object-left"
          />
        </a>
      }
      <div class="hidden w-full max-w-192 grow md:block">
        @if (currentStep > 1) {
          <cft-progress-stepper
            [activeStep]="currentStep - 1"
            [steps]="[
              {text: t('createJobRequest.steps2.step1'), icon: pencilIcon},
              {text: t('createJobRequest.steps2.step2'), icon: contactIcon},
              {text: t('createJobRequest.steps2.step3'), icon: sendIcon},
            ]"
          ></cft-progress-stepper>
        }
      </div>
      <div class="text-right">
        <button class="-mr-sm btn btn-ghost" (click)="close()">
          {{ t('createJobRequest.navbar.close') }}
          <fa-icon [icon]="closeIcon" class="ml-md text-lg"></fa-icon>
        </button>
      </div>
    </div>
  </div>
</ng-container>
